import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';
import { convertPropsToObject } from '../ContentRender';
import { RowHeader } from './RowHeader';
import ProductRow from '../../ui/ProductRow/ProductRow';
import MaxWidth from '../../Layout/MaxWidth';

const ProductRowComponentWrapper = styled('div')`
  margin: 3% 0 3%;
  ${theme.above.lg} {
    margin: 5% 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .row-header {
    margin: 0 0 2rem 0;
    ${theme.below.md} {
      margin: 0 0 1rem 0;
    }
  }
`;

const ProductRowComponent = ({ data, index }) => {
  const props = convertPropsToObject(data);
  const rowProps = {
    id: props.category.value && props.category.value.id,
    limit: props.limit.value,
    orderBy: props.orderBy.value,
    orderByDirection: props.orderByDirection.value,
    slider: props.slider.value === 'yes' ? true : false
  };

  if (!rowProps.id) return null;
  return (
    <MaxWidth data-index={index}>
      <ProductRowComponentWrapper>
        <RowHeader props={props} />
        <ProductRow {...rowProps} />
      </ProductRowComponentWrapper>
    </MaxWidth>
  );
};

export default ProductRowComponent;
